import { memo } from "react";
import Markdown from "react-markdown";
import "./terms.style.css";

interface TermsMarkdownProps {
  content: string;
  /**
   * When true, renders compactly for inline use next to a checkbox (smaller
   * margins). Use the default (false) for the full detail body.
   */
  inline?: boolean;
  className?: string;
}

/**
 * Renders partner-configured Terms & Conditions markdown. Links open in a new
 * tab so they never break the widget's single-page navigation.
 *
 * `inline` uses a `<span>` wrapper (and maps markdown `<p>` to `<span>`) so
 * the intro can sit inside a checkbox `<label>` without invalid `p > div`.
 */
export const TermsMarkdown = memo(
  ({ content, inline = false, className }: TermsMarkdownProps) => {
    const cls = `terms-markdown${inline ? " terms-markdown--inline" : ""}${
      className ? ` ${className}` : ""
    }`;
    const markdown = (
      <Markdown
        components={{
          a: ({ href, children }) => (
            <a href={href} target="_blank" rel="noopener noreferrer">
              {children}
            </a>
          ),
          ...(inline ? { p: ({ children }) => <span>{children}</span> } : {}),
        }}
      >
        {content}
      </Markdown>
    );

    if (inline) {
      return <span className={cls}>{markdown}</span>;
    }
    return <div className={cls}>{markdown}</div>;
  }
);
